var _circle, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayBtnGradientBlue(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 19,
    r: 19,
    fill: "url(#play_btn_gradient_blue_svg__paint0_linear_3552_92)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.876 18.19a1 1 0 010 1.62l-9.29 6.706a1 1 0 01-1.586-.81V12.294a1 1 0 011.585-.811l9.291 6.705z",
    fill: "#fff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "play_btn_gradient_blue_svg__paint0_linear_3552_92",
    x1: 0,
    y1: 18.999,
    x2: 37.999,
    y2: 18.999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7399EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#134FE8"
  })))));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzgiIGhlaWdodD0iMzgiIHZpZXdCb3g9IjAgMCAzOCAzOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMTkiIGN5PSIxOSIgcj0iMTkiIGZpbGw9InVybCgjcGFpbnQwX2xpbmVhcl8zNTUyXzkyKSIvPgo8cGF0aCBkPSJNMjUuODc2NCAxOC4xODkxQzI2LjQyOTUgMTguNTg4MyAyNi40Mjk1IDE5LjQxMTcgMjUuODc2NCAxOS44MTA5TDE2LjU4NTIgMjYuNTE2MkMxNS45MjM4IDI2Ljk5MzUgMTUgMjYuNTIxIDE1IDI1LjcwNTNMMTUgMTIuMjk0N0MxNSAxMS40NzkgMTUuOTIzOCAxMS4wMDY1IDE2LjU4NTIgMTEuNDgzOEwyNS44NzY0IDE4LjE4OTFaIiBmaWxsPSJ3aGl0ZSIvPgo8ZGVmcz4KPGxpbmVhckdyYWRpZW50IGlkPSJwYWludDBfbGluZWFyXzM1NTJfOTIiIHgxPSIwIiB5MT0iMTguOTk5MSIgeDI9IjM3Ljk5ODkiIHkyPSIxOC45OTkxIiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+CjxzdG9wIHN0b3AtY29sb3I9IiM3Mzk5RUYiLz4KPHN0b3Agb2Zmc2V0PSIxIiBzdG9wLWNvbG9yPSIjMTM0RkU4Ii8+CjwvbGluZWFyR3JhZGllbnQ+CjwvZGVmcz4KPC9zdmc+Cg==";
export { SvgPlayBtnGradientBlue as ReactComponent };